<template>
  <main class="content container">
    <div class="content__top">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link" href="index.html">
            Каталог
          </a>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link" href="cart.html">
            Корзина
          </a>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link">
            Оформление заказа
          </a>
        </li>
      </ul>

      <h1 class="content__title">
        Корзина
      </h1>
      <span class="content__info">
        {{ totalNum }}
      </span>
    </div>

    <section class="cart">
      <form class="cart__form form" action="#" method="POST" @submit.prevent="order">
        <div class="cart__field">
          <div class="cart__data">
            <BaseFormText v-model="formData.name" title="ФИО" placeholder="Введите ваше полное имя"
              :error="formError.name" />

            <BaseFormText v-model="formData.address"
            title="Адрес доставки" placeholder="Введите ваш адрес"
              :error="formError.address" />

            <BaseFormText v-model="formData.phone" title="Телефон"
            placeholder="Введите ваш телефон"
              :error="formError.phone" type="tel" />

            <BaseFormText v-model="formData.email" title="Email"
            placeholder="Введи ваш Email" :error="formError.email"
              type="email" />

            <BaseFormTextarea v-model="formData.comment"
            title="Комментарий к заказу" :error="formError.comment"
              placeholder="Ваши пожелания" />
          </div>

          <div class="cart__options">
            <h3 class="cart__title">Доставка</h3>
            <ul class="cart__options options">
              <li class="options__item">
                <!-- eslint-disable-next-line -->
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio"
                  name="delivery" value="0" checked="">
                  <span class="options__value">
                    Самовывоз <b>бесплатно</b>
                  </span>
                </label>
              </li>
              <li class="options__item">
                <!-- eslint-disable-next-line -->
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="delivery" value="500">
                  <span class="options__value">
                    Курьером <b>500 ₽</b>
                  </span>
                </label>
              </li>
            </ul>

            <h3 class="cart__title">Оплата</h3>
            <ul class="cart__options options">
              <li class="options__item">
                <!-- eslint-disable-next-line -->
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="pay" value="card">
                  <span class="options__value">
                    Картой при получении
                  </span>
                </label>
              </li>
              <li class="options__item">
                <!-- eslint-disable-next-line -->
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="pay" value="cash">
                  <span class="options__value">
                    Наличными при получении
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div class="cart__block">
          <OrderList />

          <button class="cart__button button button--primery" type="submit">
            Оформить заказ
          </button>
        </div>

        <div v-show="formLoading">
        <img src="../../public/img/Fidget-spinner.gif" alt="">
        </div>

        <div class="cart__error form__error-block" v-show="formErrorMessage">
          <h4>Заявка не отправлена!</h4>
          <p>
            {{ formErrorMessage }}
          </p>
        </div>
      </form>
    </section>
  </main>
</template>

<script>
import BaseFormText from '@/components/BaseFormText.vue';
import BaseFormTextarea from '@/components/BaseFormTextarea.vue';
import OrderList from '@/components/OrderList.vue';
import { API_BASE_URL } from '@/config';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      formData: {},
      formError: {},
      formErrorMessage: '',
      formLoading: false,
    };
  },
  components: { BaseFormText, BaseFormTextarea, OrderList },
  computed: {
    ...mapGetters({ products: 'cartDetailProducts', totalPrice: 'cartTotalPrice', totalNum: 'cartTotalName' }),
  },
  methods: {
    order() {
      this.formLoading = true;
      // eslint-disable-next-line
      return (new Promise(resolve => setTimeout(resolve, 2000)))
        .then(() => {
          this.formError = {};
          this.formErrorMessage = '';
          return axios
            // eslint-disable-next-line
            .post(API_BASE_URL + '/api/orders', {
              ...this.formData,
            }, {
              params: {
                userAccessKey: this.$store.state.userAccessKey,
              },
            });
        })
        // eslint-disable-next-line
        .then(response => {
          this.$store.commit('resetCart');
          this.$store.commit('updateOrderInfo', response.data);
          this.$router.push({ name: 'orderInfo', params: { id: response.data.id } });
          this.formLoading = false;
        })
        // eslint-disable-next-line
        .catch(error => {
          this.formError = error.response.data.error.request || {};
          this.formErrorMessage = error.response.data.error.message;
        });
    },
  },
};
</script>
